import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-sub-menu',
  templateUrl: './sub-menu.component.html',
  styleUrls: ['./sub-menu.component.scss']
})
export class SubMenuComponent implements OnInit {
  projectName: any;
  favorite: string;
  option: string;
  activeb: string;
  activem: string;
  option1: boolean;
  option2: boolean;

  constructor(activateRoute: ActivatedRoute) {
    this.projectName = activateRoute.snapshot.params['id'];
    console.log(this.projectName);
   }
  ngOnInit(){
    this.favorite = "fa fa-star-o";
    this.option = "build";
    this.activeb = "active nav-link";
    this.activem = "nav-link";
    this.option1 = true;
    this.option2 = false;
    this.chosenOption(this.option);
  }

  chosenFavorite(){
    switch (this.favorite) {
      case "fa fa-star-o":
        this.favorite= "fa fa-star";
        break;
      case "fa fa-star":
        this.favorite= "fa fa-star-o";
        break;
    }
  }
  chosenOption(option:string){
    switch (option) {
      case "build":
        this.activeb="active nav-link";
        this.activem= "nav-link";
        this.option1 = true;
        this.option2 = false;
        break;
      case "manage":
        this.activeb="nav-link";
        this.activem= "active nav-link";
        this.option1 = false;
        this.option2 = true;
        break;
    }
  }
}
